import { COOKIE_OPTS } from '@/services/_auth/constants/cookie'
import Cookies from 'js-cookie'

export function logout() {
  return Cookies.remove(this.getStorageKey(), COOKIE_OPTS)
}
